module.exports = __webpack_public_path__ + "static/media/Admin-2.8251428f.png";